// extracted by mini-css-extract-plugin
module.exports = {"Search":"Input_Search__15kMl","Icon":"Input_Icon__2VJ_k"};